import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, HashRouter } from "react-router-dom";

import { LanguageContext } from "./context/LanguageContext";
import useLocalStorage from "./hooks/useLocalStorage";

import en_meta from "./assets/language/en.json";
import rs_meta from "./assets/language/rs.json";
import spn_meta from "./assets/language/spn.json";

import "./index.css";
import App from "./App";

const AppWithContext = () => {
  const [lang, setLang] = useLocalStorage("lang", "eng");
  const [language, setLanguage] = useState({value: lang});
  const [data, setData] = useState(en_meta);

  useEffect(() => {
    if(language.value === "rus") {
      setLang("rus");
      return setData(rs_meta);
    }

    if(language.value === "spn") {
      setLang("spn");
      return setData(spn_meta);
    }

    setLang("eng");
    setData(en_meta);
  }, [language, lang]);

  return (
    <LanguageContext.Provider value={{ language, setLanguage, data }}>
      <HashRouter>
        <App />
      </HashRouter>
    </LanguageContext.Provider>
  );
};

ReactDOM.render(
  <AppWithContext />,
  document.getElementById("root")
);
